import { render, staticRenderFns } from "./SuficienciaPresupuestalView.vue?vue&type=template&id=2d06f8bc&"
import script from "./SuficienciaPresupuestalView.vue?vue&type=script&lang=js&"
export * from "./SuficienciaPresupuestalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports